import { AxiosInstance } from 'axios';
import { getWithAuth } from '../InitializeService';
import { buildODataQuery, ODataParams } from '@/utils/odataUtil';

export const getClientsWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`clients${buildODataQuery(params)}`, instance);
};
export const getStaffingClientsWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`staffing/dashboard/clients${buildODataQuery(params)}`, instance)
}
export const getDistinctCities = (filter: string, instance: AxiosInstance) => {
    return getWithAuth(`clients/cities?$apply=filter(${filter})/groupby((City))&$orderby=City asc`, instance);
};